import { render, staticRenderFns } from "./book-buy-invoice-button.vue?vue&type=template&id=1850f12a"
import script from "./book-buy-invoice-button.vue?vue&type=script&lang=js"
export * from "./book-buy-invoice-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports